import Swiper, { Navigation, Pagination } from "swiper";

export default class SwiperMobile {
  constructor() {
    this.init();
  }

  init() {
    Swiper.use([Navigation, Pagination]);

    new Swiper(".swiper-container", {
      slidesPerView: 1.1,
      spaceBetween: 30,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/SwiperMobile.js